import { useQuery } from 'react-query';
import * as PretaxEmployeeApi from 'apis/pretaxEmployeeDetail';
import { AxiosError } from 'axios';

export type IPretaxEmployeeDetail =
  PretaxEmployeeApi.FetchEmployeeDetailsResponse['employee_details'];

const getPretaxEmployeeDetails = async (): Promise<{
  pretax_employee_details: IPretaxEmployeeDetail;
}> => {
  const {
    data: { employee_details: pretax_employee_details },
  } = await PretaxEmployeeApi.fetchEmployeeDetails();
  return { pretax_employee_details };
};

const useQueryPretaxEmployeeDetails = ({
  is_cdh_enabled,
  onError,
}: {
  is_cdh_enabled: boolean;
  onError?: (error: AxiosError) => void;
}) => {
  const { data, isIdle, isLoading, refetch } = useQuery(
    ['getPretaxEmployeeDetails'],
    () => getPretaxEmployeeDetails(),
    {
      enabled: !!is_cdh_enabled,
      onError,
    }
  );

  return {
    data,
    isIdle,
    isLoading,
    refetch,
  };
};

export default useQueryPretaxEmployeeDetails;
